var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn dealers_btn",on:{"click":_vm.unlinkVehicle}},[_vm._v("\n    "+_vm._s(_vm.$t("text.clickButtons.unLinkVehicle"))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }